<template>
<!-- 科目管理 弹窗：批量导入科目 -->
    <el-dialog class="subjectUploadDialog" :title="errorList.length?importTextConfig.error.title:importTextConfig.title" v-if="dialogVisible" :visible.sync="dialogVisible" :width="errorList.length?'560px':'500px'" @close="close" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-upload v-if="errorList.length == 0"
                   drag action="void"
                   :limit="1" multiple
                   name="file"
                   :file-list="fileList"
                   :before-upload="beforeAvatarUpload"
                   :http-request="uploadFile"
                   :on-progress="progressA"
                   :on-remove="handleRemove"
                   :auto-upload="true"
                   style="padding-bottom:20px">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text" v-html="importTextConfig.uploadText"></div>
            <div class="el-upload__tip" slot="tip" style="text-align:center">{{ importTextConfig.uploadTip }}<el-button type="text" style="margin-left:20px"><a :href="config_env.BASE_URL+'/api/subject/download'">{{ importTextConfig.downloadBtn }}</a></el-button><p v-if="info" style="margin-top:8px"><i class="el-icon-warning-outline"></i> {{info}}</p></div>
        </el-upload>
        <div v-else>
            <p>{{ importTextConfig.error.message.signMix(errorList.length) }}</p>
              <el-table :data="errorList" stripe size="medile" :height="height" style="width: 100%">
                <el-table-column prop="line_id" :label="importTextConfig.error.line" width="90"></el-table-column>
                <el-table-column prop="reason" :label="importTextConfig.error.reason">
                    <template slot-scope="scope">
                        <span><i class="el-icon-error" style="color:#F56C6C"></i> {{scope.row.reason}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <span v-if="errorList.length" slot="footer" class="dialog-footer">
            <el-button @click="close">{{ importTextConfig.error.cancel }}</el-button>
            <el-button type="primary" @click="back">{{ importTextConfig.error.ok }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import request from '../../../utils/request'
export default {
    props: ['show'],
    data() {
        return {
            dialogVisible: false,
            errorList: [],
            height: 200,
            fileList: [],
            http: null,
            info:''
        };
    },
    computed: {
        importTextConfig() {
            return this.$store.state.global.textConfig.backend.subject.import
        }
    },
    watch: {
        show() {
            this.dialogVisible = this.show;
        }
    },
    methods: {
        beforeAvatarUpload (file) {
            this.info = ''
            var testmsg = file.name.substring(file.name.lastIndexOf('.')+1)
            const extension = testmsg === 'xls'
            const extension2 = testmsg === 'xlsx'
            const isLt2M = file.size / 1024 / 1024 < 5
            if(!extension && !extension2) {
                this.$message({
                    message: '上传文件只能是 xls、xlsx格式!',
                    type: 'warning'
                });
            }
            if(!isLt2M) {
                this.$message({
                    message: '上传文件大小不能超过 5MB!',
                    type: 'warning'
                });
            }else {
                if (file.size>250000) {
                    this.info = this.importTextConfig.error.toMany
                }
            }
            return extension || extension2 && isLt2M
        },
        uploadFile (file) {
            let f = file.file
            let formData = new FormData();
            formData.append("file", f);
            this.http = request({
                url: '/api/subject/file',
                method: 'post',
                data: formData,
                //上传进度
                onUploadProgress: (progressEvent) => {
                    let num = progressEvent.loaded / progressEvent.total * 100 | 0;  //百分比
                    file.onProgress({percent: num})     //进度条
                }
            }).then(res => {
                file.onSuccess(); //上传成功(打钩的小图标)
                this.info = ''
                if (res.status == 200) {
                    this.close()
                    this.$message({
                        message: this.importTextConfig.success,
                        type: 'success'
                    });
                    this.$parent.search(1)
                    this.dialogVisible = false
                }else {
                    this.errorList = res.data
                }
            })
        },
        handleRemove(file) {
            this.http.abort(); //取消上传
            this.$message({message: this.importTextConfig.removeSuccess.signMix(file.name), type: 'success'});
            this.errorList = []
        },
        /**     文件正在上传时的钩子    **/
        progressA(event, file) {},
        back() {
            this.errorList = []
        },
        close() {
            this.errorList = []
            this.dialogVisible = false
            this.$emit('close', false)
        },
    },
    mounted() {
        const that = this;
        function updateHeight() {
            that.height = document.querySelector('#app').clientHeight*0.8 - 206
        }
        setTimeout(() => {
            updateHeight()
        }, 200);
        window.onresize = () => {
            updateHeight()
        };
    },
};
</script>

<style>
</style>